import { Collapse, Popover } from "antd";
import { useMemo } from "react";
import styles from "../../../styles/Components/pricing-plan/new-plans/FeatureCategory.module.css";
import { FaRobot } from "react-icons/fa";
import { MdGraphicEq } from "react-icons/md";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";
import { BsSliders2 } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineArrowTopRightOnSquare } from "react-icons/hi2";

const planFeatures = {
  "Free Trial": {
    exchangeIntegration: 1,
    liveSuggestion: 3,
    bot: false,
    backtest: false,
    copyBot: false,
    sentimentAnalysis: "Delayed",
    aiSignal: "",
    signalBacktest: false,
    guideChat: 3,
    alertSystem: false,
    aiTrading: false,
    customStrategy: false,
    liveChart: false,
    aiWatchlist: false,
    tradeSimulator: false,
    developerApi: false,
    coreFeature: 5,
    botFeature: 0,
    aiFeature: 2,
    advanceFeature: 0,
  },
  Lite: {
    exchangeIntegration: 2,
    liveSuggestion: 30,
    bot: 1,
    backtest: 5,
    copyBot: true,
    sentimentAnalysis: 5,
    aiSignal: "",
    signalBacktest: false,
    guideChat: 10,
    alertSystem: false,
    aiTrading: false,
    customStrategy: false,
    liveChart: false,
    aiWatchlist: false,
    tradeSimulator: false,
    developerApi: false,
    coreFeature: 5,
    botFeature: 3,
    aiFeature: 2,
    advanceFeature: 0,
  },
  Pro: {
    exchangeIntegration: 10,
    liveSuggestion: 300,
    bot: 5,
    backtest: 20,
    copyBot: true,
    sentimentAnalysis: 10,
    aiSignal: "Unlimited",
    signalBacktest: "Unlimited",
    guideChat: 50,
    alertSystem: true,
    aiTrading: true,
    customStrategy: true,
    liveChart: true,
    aiWatchlist: true,
    tradeSimulator: false,
    developerApi: false,
    coreFeature: 5,
    botFeature: 3,
    aiFeature: 4,
    advanceFeature: 4,
  },
  Enterprise: {
    planKey: "",
    exchangeIntegration: 25,
    liveSuggestion: "Unlimited",
    bot: 20,
    backtest: 50,
    copyBot: true,
    sentimentAnalysis: "Unlimited",
    aiSignal: "Unlimited",
    signalBacktest: "Unlimited",
    guideChat: 150,
    alertSystem: true,
    aiTrading: true,
    customStrategy: true,
    liveChart: true,
    aiWatchlist: true,
    tradeSimulator: true,
    developerApi: true,
    coreFeature: 5,
    botFeature: 3,
    aiFeature: 4,
    advanceFeature: 6,
  },
};

function FeatureCategory({
  plan,
  availableFeaturesNumber,
  featuresAvailability = [],
  expandedFeature,
  handleExpandedFeature,
}) {
  // const [extendFeature, setExtendFeature] = useState(["core"]);

  const navigate = useNavigate();

  const collapseItems = useMemo(() => {
    return [
      {
        key: "core",
        label: (
          <div className={styles.categoryLabel}>
            <div className={styles.availableFeatureNum}>
              <span>{planFeatures?.[plan]?.coreFeature}</span> / <span>5</span>{" "}
            </div>
            <span className={styles.categoryName}>
              <HiOutlineSwitchHorizontal /> Core Trading
            </span>
          </div>
        ),
        children: (
          <ul className={styles.featureList}>
            <li>
              <span>
                Terminal Trading{" "}
                <Popover
                  content={
                    <div className={styles.popoverContent}>
                      <h4>Buy/Sell forms in:</h4>
                      <Link to="/ai-assistant">AI Assistant</Link>{" "}
                      <Link to="/portfolio">Portfolio</Link>
                      <Link to="/insight">Insights</Link>
                    </div>
                  }
                >
                  <HiOutlineArrowTopRightOnSquare
                    color="#0c4cfc"
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  />
                </Popover>
              </span>
            </li>
            <li>
              <span>
                AI Signals ( 5-Minute Delay){" "}
                <Link
                  to="/dashboard#latest-signals"
                  style={{ marginLeft: "4px" }}
                >
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li>
              <strong>{planFeatures?.[plan]?.exchangeIntegration}</strong>
              <span>
                Exchange Connection{" "}
                <Link to="/portfolio" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li>
              <strong>
                {planFeatures?.[plan]?.sentimentAnalysis}{" "}
                {typeof planFeatures?.[plan]?.sentimentAnalysis === "number" &&
                  "Daily"}
              </strong>
              <span>
                Sentiment Analysis{" "}
                <Link
                  to="/dashboard#market-overview"
                  style={{ marginLeft: "4px" }}
                >
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li>
              <span>
                Paper Trading on a Demo account
                <Popover
                  content={
                    <div className={styles.popoverContent}>
                      <h4>Buy/Sell forms in:</h4>
                      <Link to="/ai-assistant">AI Assistant</Link>{" "}
                      <Link to="/portfolio">Portfolio</Link>
                      <Link to="/insight">Insights</Link>
                    </div>
                  }
                >
                  <HiOutlineArrowTopRightOnSquare
                    color="#0c4cfc"
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  />
                </Popover>
              </span>
            </li>
          </ul>
        ),
      },
      {
        key: "ai",
        label: (
          <div className={styles.categoryLabel}>
            <div className={styles.availableFeatureNum}>
              <span>{planFeatures?.[plan]?.aiFeature}</span> / <span>4</span>{" "}
            </div>
            <span className={styles.categoryName}>
              <MdGraphicEq />
              AI Assistant
            </span>
          </div>
        ),
        children: (
          <ul className={styles.featureList}>
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.aiSignal ? 1 : 0.5}`,
              }}
            >
              {typeof planFeatures?.[plan]?.aiSignal === "string" && (
                <strong>{planFeatures?.[plan]?.aiSignal}</strong>
              )}
              <span>
                AI Assistant Suggestions{" "}
                <Link to="/ai-assistant" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li>
              <strong>
                {planFeatures?.[plan]?.liveSuggestion}{" "}
                {typeof planFeatures?.[plan]?.liveSuggestion === "number" &&
                  "Daily"}
              </strong>
              <span>
                Pivot checks{" "}
                <Popover
                  content={
                    <div className={styles.popoverContent}>
                      <h4>Buy/Sell forms in:</h4>
                      <Link to="/ai-assistant">AI Assistant</Link>{" "}
                      <Link to="/portfolio">Portfolio</Link>
                      <Link to="/insight">Insights</Link>
                    </div>
                  }
                >
                  <HiOutlineArrowTopRightOnSquare
                    color="#0c4cfc"
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  />
                </Popover>
              </span>
            </li>
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.signalBacktest ? 1 : 0.5}`,
              }}
            >
              {planFeatures?.[plan]?.signalBacktest && (
                <strong>{planFeatures?.[plan]?.signalBacktest}</strong>
              )}
              <span>
                Signal Backtest{" "}
                <Popover
                  content={
                    <div className={styles.popoverContent}>
                      <Link to="/ai-assistant">
                        AI Assistant - Run AI Backtest
                      </Link>
                    </div>
                  }
                >
                  <HiOutlineArrowTopRightOnSquare
                    color="#0c4cfc"
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  />
                </Popover>
              </span>
            </li>
            <li>
              <strong>
                {planFeatures?.[plan]?.guideChat}{" "}
                {typeof planFeatures?.[plan]?.guideChat === "number" &&
                  "Daily"}
              </strong>
              <span>
                Guide questions{" "}
                <Link to="/ai-assistant" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
          </ul>
        ),
      },
      {
        key: "bot",
        label: (
          <div className={styles.categoryLabel}>
            <div className={styles.availableFeatureNum}>
              <span>{planFeatures?.[plan]?.botFeature}</span> / <span>3</span>{" "}
            </div>
            <span className={styles.categoryName}>
              <FaRobot /> AI Bot
            </span>
          </div>
        ),
        children: (
          <ul className={styles.featureList}>
            <li style={{ opacity: `${planFeatures?.[plan]?.bot ? 1 : 0.5}` }}>
              {planFeatures?.[plan]?.bot && (
                <strong>{planFeatures?.[plan]?.bot}</strong>
              )}
              <span>
                Trading Bots{" "}
                <Popover
                  content={
                    <div className={styles.popoverContent}>
                      <Link to="/bot-automation">AI Bot</Link>{" "}
                      <Link to="/dashboard">Dashboard</Link>
                    </div>
                  }
                >
                  <HiOutlineArrowTopRightOnSquare
                    color="#0c4cfc"
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  />
                </Popover>
              </span>
            </li>
            <li
              style={{ opacity: `${planFeatures?.[plan]?.backtest ? 1 : 0.5}` }}
            >
              {planFeatures?.[plan]?.backtest && (
                <strong>{planFeatures?.[plan]?.backtest} per month</strong>
              )}
              <span>
                Bot Backtests{" "}
                <Popover
                  content={
                    <div className={styles.popoverContent}>
                      <Link to="/bot-automation">AI Bot</Link>{" "}
                      <Link to="/dashboard">Dashboard</Link>
                    </div>
                  }
                >
                  <HiOutlineArrowTopRightOnSquare
                    color="#0c4cfc"
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  />
                </Popover>
              </span>
            </li>
            <li
              style={{ opacity: `${planFeatures?.[plan]?.copyBot ? 1 : 0.5}` }}
            >
              {/*{planFeatures?.[plan]?.copyBot && (*/}
              {/*  <strong>{planFeatures?.[plan]?.copyBot} per month</strong>*/}
              {/*)}*/}
              <span>
                Copy Trading Bots{" "}
                <Popover
                  content={
                    <div className={styles.popoverContent}>
                      <Link to="/bot-automation#community-bots">
                        AI Bot - Community Bots
                      </Link>{" "}
                      <Link to="/dashboard#community-bots">
                        Dashboard - Community Bots
                      </Link>
                    </div>
                  }
                >
                  <HiOutlineArrowTopRightOnSquare
                    color="#0c4cfc"
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  />
                </Popover>
              </span>
            </li>
          </ul>
        ),
      },
      {
        key: "advances",
        label: (
          <div className={styles.categoryLabel}>
            <div className={styles.availableFeatureNum}>
              <span>{planFeatures?.[plan]?.advanceFeature}</span>/{" "}
              <span>6</span>
            </div>
            <span className={styles.categoryName}>
              <BsSliders2 /> Advanced
            </span>
          </div>
        ),
        children: (
          <ul className={styles.featureList}>
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.alertSystem ? 1 : 0.5}`,
              }}
            >
              <span>
                Alert System{" "}
                <Link to="/alert-system" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            {/*<li>*/}
            {/*  <strong>*/}
            {/*    {planFeatures?.[plan]?.sentimentAnalysis}{" "}*/}
            {/*    {typeof planFeatures?.[plan]?.sentimentAnalysis === "number" &&*/}
            {/*      "Daily"}*/}
            {/*  </strong>*/}
            {/*  <span>Sentiment Analysis</span>*/}
            {/*</li>*/}
            {/*<li*/}
            {/*  style={{*/}
            {/*    opacity: `${planFeatures?.[plan]?.aiTrading ? 1 : 0.5}`,*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <span>AI-assisted Trading</span>*/}
            {/*</li>*/}
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.customStrategy ? 1 : 0.5}`,
              }}
            >
              <span>
                Custom Strategy Builder{" "}
                <Link to="/insight" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.liveChart ? 1 : 0.5}`,
              }}
            >
              <span>
                Pivot chart{" "}
                <Link to="/insight" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.aiWatchlist ? 1 : 0.5}`,
              }}
            >
              <span>
                AI Watchlist{" "}
                <Link to="/insight" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.tradeSimulator ? 1 : 0.5}`,
              }}
            >
              <span>
                Trade Simulator{" "}
                <Link to="/trade-simulator" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
            <li
              style={{
                opacity: `${planFeatures?.[plan]?.developerApi ? 1 : 0.5}`,
              }}
            >
              <span>
                Developer API{" "}
                <Link to="/developer-api" style={{ marginLeft: "4px" }}>
                  <HiOutlineArrowTopRightOnSquare color="#0c4cfc" />
                </Link>
              </span>
            </li>
          </ul>
        ),
      },
    ];
  }, [plan]);

  const changeExpandedFeature = (key) => {
    if (key.length) {
      const lastKey = key?.[key.length - 1];
      handleExpandedFeature(lastKey);
      return;
    }
    handleExpandedFeature(key);
    // console.log(key);
    // setExtendFeature(key);
  };

  return (
    <Collapse
      items={collapseItems}
      activeKey={expandedFeature}
      onChange={changeExpandedFeature}
      bordered={false}
      // expandIcon={<FaAngleDown />}
      expandIconPosition="end"
      ghost
      className={styles.container}
    ></Collapse>
  );
}

export default FeatureCategory;
